import script from "./TableComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableComponent.vue?vue&type=script&setup=true&lang=ts"

import "./TableComponent.vue?vue&type=style&index=0&id=1ec84733&scoped=true&lang=scss"

import exportComponent from "/builds/kligmanbb/medsafe-smart-pro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec84733"]])

export default __exports__
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMarkupTable,QCheckbox,QIcon,QBtn,QMenu,QSelect,QPagination});
